import React from 'react';

const CoinIcon = () => {
	return (
		<svg
			width={32}
			height={32}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16 4C9.37284 4 4 9.37284 4 16C4 22.6272 9.37284 28 16 28C22.6272 28 28 22.6272 28 16C28 9.37284 22.6272 4 16 4ZM19.4469 20.7309C18.9235 21.3679 18.242 21.7975 17.4469 22.0148C17.1012 22.1086 16.9432 22.2914 16.963 22.6519C16.9778 23.0074 16.963 23.358 16.958 23.7136C16.958 24.0296 16.7951 24.1975 16.484 24.2074C16.2815 24.2123 16.079 24.2173 15.8765 24.2173C15.6988 24.2173 15.521 24.2173 15.3432 24.2123C15.0074 24.2074 14.8494 24.0148 14.8494 23.6889C14.8444 23.4321 14.8444 23.1704 14.8444 22.9136C14.8395 22.3407 14.8198 22.321 14.2716 22.2321C13.5704 22.1185 12.879 21.9605 12.237 21.6494C11.7333 21.4025 11.679 21.279 11.8222 20.7457C11.9309 20.3506 12.0395 19.9556 12.163 19.5654C12.2519 19.279 12.3358 19.1506 12.4889 19.1506C12.5778 19.1506 12.6914 19.1951 12.8444 19.2741C13.5556 19.6444 14.3111 19.8519 15.1062 19.9506C15.2395 19.9654 15.3728 19.9753 15.5062 19.9753C15.8765 19.9753 16.237 19.9062 16.5877 19.7531C17.4716 19.3679 17.6099 18.3457 16.8642 17.7333C16.6123 17.5259 16.321 17.3728 16.0198 17.2395C15.2444 16.8988 14.4395 16.642 13.7086 16.2025C12.5235 15.4914 11.7728 14.5185 11.8617 13.0765C11.9605 11.4469 12.884 10.4296 14.3802 9.88642C14.9975 9.6642 15.0025 9.66914 15.0025 9.02716C15.0025 8.80988 14.9975 8.59259 15.0074 8.37037C15.0222 7.88642 15.1012 7.80247 15.5852 7.78765C15.6395 7.78765 15.6988 7.78765 15.7531 7.78765C15.8469 7.78765 15.9407 7.78765 16.0346 7.78765C16.0741 7.78765 16.1136 7.78765 16.1481 7.78765C17.0667 7.78765 17.0667 7.82716 17.0716 8.81975C17.0765 9.55062 17.0765 9.55062 17.8025 9.6642C18.3605 9.75309 18.8889 9.91605 19.4025 10.1432C19.684 10.2667 19.7926 10.4642 19.7037 10.7654C19.5753 11.2099 19.4519 11.6593 19.3136 12.0988C19.2247 12.3654 19.1407 12.4889 18.9827 12.4889C18.8938 12.4889 18.7852 12.4543 18.6469 12.3852C17.9358 12.0395 17.1901 11.8716 16.4099 11.8716C16.3111 11.8716 16.2074 11.8765 16.1086 11.8815C15.8765 11.8963 15.6494 11.9259 15.4321 12.0198C14.6617 12.3556 14.5383 13.2049 15.1951 13.7284C15.5259 13.9951 15.9062 14.1827 16.2963 14.3457C16.9778 14.6272 17.6593 14.8988 18.3062 15.2543C20.3407 16.3901 20.8938 18.9728 19.4469 20.7309Z"
				fill="url(#paint0_linear_243_5676)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_243_5676"
					x1={4}
					y1={28}
					x2={28}
					y2={28}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFBF1A" />
					<stop offset={1} stopColor="#FCD535" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default CoinIcon;
